import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
    Upload,
    Tooltip,
    Tag,
    Space,
    Radio
} from "antd";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    DatePickerItem,
    ModalItem,
    ButtonItem,
    InputItem,
    TextAreaItem,
    NotificacionPolizas,
    NotificacionMovimientosInventario,
    ErrorItem,
    SelectInsumosItem,
    // FirmaCanvasItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { EyeOutlined, DeleteOutlined, PlusOutlined, UploadOutlined, DatabaseOutlined,TagsOutlined } from "@ant-design/icons";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import MandarCorreoComodato from "../MandarCorreoComodato/MandarCorreoComodato";

const { Option } = Select;

moment.locale("es");

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

class AgregarOrdenComodato extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        tipoEntidad: 'cliente',
        objetoClientes: null,
        todasClientes: null,
        objetoProveedores: null,
        todasProveedores: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoInsumos: (
            <Option disabled value={0} key={0}>
                Seleccione un proveedor primero
            </Option>
        ),
        todasInsumos: [],
        modalConfirmacion: false,
        valuesForm: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteId: null,
        modalElegirTipoDeClienteNombre: null,
        archivosXml: [],
        empresaRfc: null,
        rendered: 0,
        ajusteMax: 0,
        modalAgregarMarbetes: false,
        modalAgregarMarbetesIndex: null,
        modalAgregarMarbetesMarbetes: null,
        estadoCC: false,
        xmlFile: null,
        xmltotales: null,
        mensajeMostrado: false,
        modalMandarCorreoComodato: false,
        modalMandarCorreoComodatoId: null,
        archivos: []
    };
    async componentDidMount() {
        this.setState({ loading: true });
        await this.consultarTodo()
        if (this.state.comodatoPorDefectoProveedor) {
            this.setState({ tipoEntidad: 'proveedor' });
        }
        this.setState({ loading: false });
    }

    async consultarTodo() {


        const responseOrden = axios.post("comodato/selectDatosParaOrden",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken });

        const responseProveedores = axios.post("proveedores/selectProveedores",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken });

        const [resOrden, resProveedores] = await Promise.all([responseOrden, responseProveedores]);

        if (resOrden.data.success === 2) {
            this.setState({
                todasClientes: resOrden.data.clientes,
                objetoClientes: resOrden.data.clientes.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.stringBuscar}
                    </Option>
                )),
                todasProyectos: resOrden.data.proyectos,
                objetoProyectos: resOrden.data.proyectos.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.nombre}
                    </Option>
                )),
                comodatoPorDefectoProveedor: resOrden.data.comodatoPorDefectoProveedor
            });
        } else {
            message.error("Hubo un error al cargar los datos");
        }

        if (resProveedores.data && !resProveedores.data.status) {
            this.setState({
                todasProveedores: resProveedores.data,
                objetoProveedores: resProveedores.data.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.stringBuscar}
                    </Option>
                )),
            });
        }

    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "comodato/agregarOrden",
                {
                    ...values,
                    tipoEntidad: this.state.tipoEntidad,
                    archivos: this.state.archivos,
                    empresaId: this.props.empresaId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success(
                        "Se ha registrado una orden"
                    );
                    NotificacionPolizas(res.data.polizasId)
                    NotificacionMovimientosInventario(res.data.movimientosIds)
                    this.abrirMandarCorreoComodato(res.data.id);
                } else if (res.data.success === 1) {
                    message.warning(res.data.message);
                } else {
                    message.error("Hubo un error y la factura no se registro");
                }
            });
    }

    atras() {
        this.props.history.push('/panel/comodato');
    }
    async actualizarBoton() {
        await this.consultarTodo()
        let arrayValue = this.formRef.current.getFieldValue("insumos");
        if (arrayValue?.length > 0) {
            arrayValue.map((valueInsumo, key) => this.onChangePrecioCantidadDescuento(undefined, key))
        }
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({ modalElegirTipoDeCliente: true, modalElegirTipoDeClienteId: id, modalElegirTipoDeClienteNombre: nombre });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined })
        }
        this.consultarTodo()
        this.setState({ modalElegirTipoDeCliente: false, modalElegirTipoDeClienteId: null, modalElegirTipoDeClienteNombre: null });
    }

    abrirAgregarMarbetes(value, marbetes, insumoId) {
        this.setState({
            modalAgregarMarbetes: true,
            modalAgregarMarbetesIndex: value,
            modalAgregarMarbetesMarbetes: marbetes,
            modalAgregarMarbetesInsumoId: insumoId
        })
    }

    cerrarAgregarMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalAgregarMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalAgregarMarbetes: false,
            modalAgregarMarbetesIndex: null,
            modalAgregarMarbetesMarbetes: null,
            modalAgregarMarbetesInsumoId: null
        })
    }

    abrirAgregarLotes(value, lotes, insumoId, tipoEspecie, vehiculo) {
        this.setState({
            modalAgregarLotes: true,
            modalAgregarLotesIndex: value,
            modalAgregarLotesLotes: lotes,
            modalAgregarLotesInsumoId: insumoId,
            modalAgregarLotesFechaIngresoM: this.props.taxidermia ? this.formRef.current.getFieldValue('fechaOrden') : undefined,
            modalAgregarLotesTipoEspecie: tipoEspecie ? tipoEspecie : '',
            modalAgregarLotesVehiculo: vehiculo,
        })
    }

    cerrarAgregarLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalAgregarLotesIndex].lotes = value
        if( this.props.taxidermia && value[0]?.numero) {
            insumos[this.state.modalAgregarLotesIndex].codigo = value[0].numero
        }
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalAgregarLotes: false,
            modalAgregarLotesIndex: null,
            modalAgregarLotesLotes: null,
            modalAgregarLotesInsumoId: null,
            modalAgregarLotesFechaIngresoM: null,
            modalAgregarLotesTipoEspecie: null
        })
    }

    onChangeTipoEntidad(e) {
        this.setState({ tipoEntidad: e.target.value });
        this.formRef.current.setFieldsValue({ clienteId: undefined, proveedorId: undefined });
    }

    onChangeProveedor(valueId) {
        const proveedor = this.state.todasProveedores.find((p) => p._id === valueId);
        if (!proveedor) return;
        this.formRef.current.setFieldsValue({
            proyectoId: proveedor.proyectoId,
        });
    }

    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            precioId:
                contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId,
            usoDeCfdiId: cliente.usoDeCFDIID,
            proyectoId: cliente.proyectoId,
        });
    }

    async onChangeInsumo(value, key, insumoEncontrado) {
        const proyectoId = await this.formRef.current.getFieldValue("proyectoId");
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
            insumo = insumoEncontrado;
            const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
            if (!yaExiste) {
            await this.setState(prev => ({
                todasInsumos: [...prev.todasInsumos, insumo]
            }));
            }
        } else {
            insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
            );
        }
        this.setState({ loading: false });
        if (!insumo) return
        arrayValue[key].codigo = insumo.codigo
        arrayValue[key].unidad = insumo.unidad
        arrayValue[key].lotes = []
        arrayValue[key].marbetes = []

        if (!arrayValue[key].proyectoId) {
            arrayValue[key].proyectoId = proyectoId;
        }

        if (this.props.taxidermia) {
            arrayValue[key].cantidad = 1
        }

        await this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });

        if (this.props.taxidermia && insumo?.lotesCaducidades) {
            this.abrirAgregarLotes(key, arrayValue[key].lotes, arrayValue[key]?.insumoId, insumo.descripcion, insumo.vehiculo);
        }

    }


    onChangeProyecto(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')

        if (Array.isArray(insumos) && insumos.length > 0) {
            const nuevosInsumos = insumos.map(insumo => {
                if (insumo && !insumo?.proyectoId) {
                    insumo.proyectoId = value
                }
                return insumo
            })
            this.formRef.current.setFieldsValue({
                insumos: nuevosInsumos
            })
        }
    }

    abrirMandarCorreoComodato(id) {
        this.setState({
            modalMandarCorreoComodato: true,
            modalMandarCorreoComodatoId: id,
        });
    }

    cerrarMandarCorreoComodato() {
        this.setState({
            modalMandarCorreoComodato: false,
            modalMandarCorreoComodatoId: null,
        });
        this.formRef.current.resetFields();
        this.atras();
    }

    customRequestArchivos = async (e) => {
        const file = e.file;
        const isPDF = file.type === 'application/pdf';
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isPDF) {
            message.error(`${file.name} no es un archivo PDF válido`);
            e.onError('Tipo de archivo inválido');
            return;
        }

        if (!isLt5M) {
            message.error(`${file.name} supera los 25 MB`);
            e.onError('Archivo demasiado grande');
            return;
        }

        const base64 = await getBase64(file);

        const nuevoArchivo = {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: base64,
            originFileObj: file,
        };

        this.setState((prev) => {
            const anteriores = prev.archivos || [];
            return {
                archivos: [...anteriores, nuevoArchivo]
            };
        });

        e.onSuccess("ok");
    };

    beforeUploadArchivos = (file) => {
        const isPDF = file.type === 'application/pdf';
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isPDF) {
            message.error(`${file.name} no es un archivo PDF válido`);
            return Upload.LIST_IGNORE;
        }

        if (!isLt5M) {
            message.error(`${file.name} excede el tamaño máximo de 25MB`);
            return Upload.LIST_IGNORE;
        }

        return true;
    };


    onRemoveFileArchivos = (file) => {
        const archivos = this.state.archivos || [];
        const filtrado = archivos.filter((item) => item.uid !== file.uid);

        this.setState((prev) => ({
            archivos: filtrado,
        }));
    };

    handlePreviewArchivo = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImageArchivo: file.url || file.preview,
            previewVisibleArchivo: true,
            previewTitleArchivo: file.name || '',
        },);
    };

    handleCancelArchivo = () => this.setState({ previewVisibleArchivo: false });

    getInsumosColumns() {
        return [
            { title: "Codigo",   width: "10%" },
            { title: "Insumo",   width: "25%" },
            { title: "Unidad",   width: "5%" },
            { title: "Proyecto", width: "20%" },
            { title: "Cantidad", width: "10%" },
            { title: "Acción",   width: "15%" },
        ];
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove }) {
        const insumos = this.formRef.current?.getFieldValue('insumos') || [];
        const estadoCCPrimeroAqui = insumos[arrayKey]?.estadoCC && !insumos[arrayKey - 1]?.estadoCC;

        return (
            <React.Fragment key={key}>
                {estadoCCPrimeroAqui && (
                    <tr>
                        <td className="td-border-sin-right" colSpan="12" style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 20, paddingLeft: 10 }}>
                            <h1 style={{ paddingTop: 0, paddingBottom: 0 }}>Estado de Cuenta Combustibles</h1>
                        </td>
                    </tr>
                )}
                <tr>
                    {/* Codigo */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "codigo"]}
                            fieldKey={[arrayKey, "codigo"]}
                            noStyle
                            disabled
                        >
                            <InputItem
                                sinBorde
                                disabled
                                autoFocus
                                style={{ width: "100%" }}
                                placeholder="Codigo"
                            />
                        </FormItem>
                    </td>
                    {/* Insumo */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "insumoId"]}
                            fieldKey={[arrayKey, "insumoId"]}
                            required
                            noStyle
                        >
                            <SelectInsumosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo"
                                tiposInsumos="inventariables"
                                onChange={(value, insumo) =>
                                    this.onChangeInsumo(value, arrayKey, insumo)
                                }
                                ocultarUnidad
                            />
                        </FormItem>
                    </td>
                     <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                                const insumoSeleccionado = this.state.todasInsumos?.find(
                                    (insumo) => insumo._id.toString() === insumoId?.toString()
                                );
                                return (
                                    <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                                        {insumoSeleccionado?.unidad || '-'}
                                    </div>
                                );
                            }}
                        </FormItem>
                     
                        <FormItem {...restField} name={[name, "unidad"]} fieldKey={[arrayKey, "unidad"]} noStyle hidden>
                            <InputItem />
                        </FormItem>
                    </td>
                    {/* Proyecto */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "proyectoId"]}
                            fieldKey={[arrayKey, "proyectoId"]}
                            required
                            noStyle
                        >
                            <SelectItem
                                sinBorde
                                style={{ width: "100%" }}
                                placeholder="Proyecto"
                            >
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                    </td>
                   
                    {/* Cantidad */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "cantidad"]}
                            fieldKey={[arrayKey, "cantidad"]}
                            required
                            number
                            noStyle
                        >
                            <InputNumberItem
                                sinBorde
                                placeholder="Cantidad"
                            />
                        </FormItem>
                    </td>
                    <td className="td-border-sin-right">
                        <Row className="acciones-container">
                            <Col span={24}>
                                <FormItem noStyle shouldUpdate>
                                    {({ getFieldValue }) => {
                                        let arrayValue = getFieldValue("insumos");
                                        let mostrarMarbetes = false;
                                        let mostrarLotes = false;
                                        let descripcion;
                                        let mostrarVehiculo = null;
                                        if (arrayValue[arrayKey]?.insumoId) {
                                            const insumo = this.state.todasInsumos.find(
                                                (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                            );
                                            mostrarMarbetes = insumo?.marbetes;
                                            mostrarLotes = insumo?.lotesCaducidades;
                                            descripcion = insumo?.descripcion;
                                            mostrarVehiculo = insumo?.vehiculo;
                                        }
                                        return (
                                            <Space
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center"
                                                }}
                                                size={4}
                                                className="acciones-container"
                                            >
                                                <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                    <ButtonItem
                                                        rojo2
                                                        icon={<DeleteOutlined />}
                                                        onClick={() => remove(name)}
                                                        size="small"
                                                    />
                                                </Tooltip>
                                                {mostrarLotes && (
                                                    <Tooltip title={this.props.taxidermia ? 'Animales' : 'Lotes'} placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                        <ButtonItem
                                                            type="primary"
                                                            size="small"
                                                             cyan2
                                                            icon={<DatabaseOutlined />}
                                                            onClick={() => {
                                                                this.abrirAgregarLotes(arrayKey, arrayValue[arrayKey]?.lotes, arrayValue[arrayKey]?.insumoId, descripcion, mostrarVehiculo);
                                                            }}
                                                        >
                                                            {this.props.taxidermia ? 'Animales' : 'Lotes'}
                                                        </ButtonItem>
                                                    </Tooltip>
                                                )}
                                                {mostrarMarbetes && (
                                                    <Tooltip title="Marbetes" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                        <ButtonItem
                                                            type="primary"
                                                            size="small"
                                                            amarillo2
                                                            icon={<TagsOutlined />}
                                                            onClick={() => {
                                                                this.abrirAgregarMarbetes(arrayKey, arrayValue[arrayKey]?.marbetes, arrayValue[arrayKey]?.insumoId);
                                                            }}
                                                        >
                                                            Marbetes
                                                        </ButtonItem>
                                                    </Tooltip>
                                                )}
                                            </Space>
                                        );
                                    }}
                                </FormItem>
                            </Col>
                        </Row>
                    </td>
                </tr>
            </React.Fragment>
        );
    }

    render() {
        const isMobile = window.innerWidth < 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Orden de Comodato"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="agregarFacturaSinOrdenDeCompra"
                            layout
                            onFinish={(values) => this.setState({ modalConfirmacion: true, valuesForm: values })}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <GeneralFormLayout
                                isMobile={isMobile}
                                cards={[
                                    {
                                        title: "Datos Generales",
                                        lg: 13,
                                        content: (
                                            <>
                                                <Row>
                                                    <Col span={18} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Tipo" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin>
                                                            <Radio.Group
                                                                value={this.state.tipoEntidad}
                                                                onChange={this.onChangeTipoEntidad.bind(this)}
                                                                buttonStyle="solid"
                                                            >
                                                                <Radio.Button value="cliente">Cliente</Radio.Button>
                                                                <Radio.Button value="proveedor">Proveedor</Radio.Button>
                                                            </Radio.Group>
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                {this.state.tipoEntidad === 'cliente' ? (
                                                <Row>
                                                    <Col span={18} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Cliente" name="clienteId" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                            <SelectItem placeholder="Cliente" onChange={this.onChangeCliente.bind(this)}>
                                                                {this.state.objetoClientes}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                    <Col span={6} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                        <FormItem shouldUpdate noStyle>
                                                            {({ getFieldValue }) => {
                                                                const clienteId = getFieldValue("clienteId");
                                                                if (!clienteId) return null;
                                                                const cliente = this.state.todasClientes?.find((v) => v._id === clienteId);
                                                                if (!cliente) return null;
                                                                return (
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <p style={{ margin: 0 }}>
                                                                            RFC:{" "}
                                                                            <Tag color="default" style={{ fontWeight: "bold" }}>
                                                                                {cliente.rfc}
                                                                            </Tag>
                                                                        </p>
                                                                    </div>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                ) : (
                                                <Row>
                                                    <Col span={18} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Proveedor" name="proveedorId" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                            <SelectItem placeholder="Proveedor" onChange={this.onChangeProveedor.bind(this)}>
                                                                {this.state.objetoProveedores}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                    <Col span={6} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                        <FormItem shouldUpdate noStyle>
                                                            {({ getFieldValue }) => {
                                                                const proveedorId = getFieldValue("proveedorId");
                                                                if (!proveedorId) return null;
                                                                const proveedor = this.state.todasProveedores?.find((v) => v._id === proveedorId);
                                                                if (!proveedor) return null;
                                                                return (
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <p style={{ margin: 0 }}>
                                                                            RFC:{" "}
                                                                            <Tag color="default" style={{ fontWeight: "bold" }}>
                                                                                {proveedor.rfc}
                                                                            </Tag>
                                                                        </p>
                                                                    </div>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                )}
                                                <Row>
                                                    <Col span={24} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Proyecto" name="proyectoId" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin required>
                                                            <SelectItem placeholder="Proyecto" onChange={(value) => this.onChangeProyecto(value)}>
                                                                {this.state.objetoProyectos}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Remisión" name="remision" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin pattern max={100}>
                                                            <InputItem placeholder="Remisión del proveedor" />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Observaciones" name="observaciones" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin pattern max={500}>
                                                            <TextAreaItem placeholder="Observaciones generales" autoSize={{ minRows: 2, maxRows: 4 }} />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                  {/* <Row>
                                                        <FormItem label="Proyecto" name="firma" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} margin required>
                                                                <FirmaCanvasItem />
                                                        </FormItem>
                                                    </Row> */}
                                            </>
                                        ),
                                    },
                                    {
                                        title: "Fechas",
                                        lg: 11,
                                        content: (
                                         <>
                                        <Row gutter={16}>

                                            <Col span={12}>
                                            <FormItem label="Fecha de Orden" name="fechaOrden" required margin labelCol={{ span: 13 }} wrapperCol={{ span: 11 }}>
                                                <DatePickerItem
                                                placeholder="Fecha de Orden"
                                                allowClear={false}
                                                disabledDate={(current) =>
                                                    current && current > moment().endOf("day")
                                                }
                                                />
                                            </FormItem>
                                            </Col>

                                            {!this.props.taxidermia && (
                                            <Col span={12}>
                                                <FormItem label="Fecha de Entrega" name="fechaEntrega" required={this.props.comodatoFechaEntregaObligatoria} margin   labelCol={{ span: 13 }} wrapperCol={{ span: 11 }}>
                                                <DatePickerItem
                                                    placeholder="Fecha de Entrega"
                                                    allowClear={false}
                                                    disabledDate={
                                                    this.props.comodatoFechaEntregaObligatoria
                                                        ? undefined
                                                        : (current) => current && current < moment().startOf("day")
                                                    }
                                                />
                                                </FormItem>
                                            </Col>
                                            )}
                                        </Row>

                                        <Row>
                                            <Col span={24}>
                                            <FormItem
                                                name={"archivos"}
                                                fieldKey={"archivos"}
                                                margin                              
                                                style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                textAlign: "center",
                                                width: "100%",
                                                }}
                                            >
                                                <Upload
                                                accept=".pdf"
                                                showUploadList={{
                                                    showRemoveIcon: true,
                                                    showPreviewIcon: true,
                                                    previewIcon: <EyeOutlined style={{ color: "#1890ff" }} />,
                                                    removeIcon: <DeleteOutlined style={{ color: "red" }} />,
                                                }}
                                                fileList={this.state.archivos || []}
                                                customRequest={(e) => this.customRequestArchivos(e)}
                                                beforeUpload={this.beforeUploadArchivos}
                                                onRemove={(file) => this.onRemoveFileArchivos(file)}
                                                onPreview={this.handlePreviewArchivo.bind(this)}
                                                >
                                                {this.state.archivos?.length >=
                                                (this.props.taxidermia ? 5 : 3) ? null : (
                                                    <ButtonItem
                                                    blanco
                                                    icon={<UploadOutlined />}
                                                    style={{ padding: "0px 20px" }}
                                                    >
                                                    Archivos
                                                    </ButtonItem>
                                                )}
                                                </Upload>
                                            </FormItem>
                                            </Col>
                                        </Row>
                                        </>
                                        ),
                                    },
                                ]}
                                tabsConfig={{
                                    tabs: [
                                        {
                                            key: "insumos",
                                            label: "Insumos",
                                            listName: "insumos",
                                            columns: this.getInsumosColumns(),
                                            renderRow: this.renderInsumoRow.bind(this),
                                            renderFooter: ({ add, fields }) => (
                                                <FormItem noStyle>
                                                    <ButtonItem
                                                        style={{
                                                            marginTop: 10,
                                                            marginBottom: 10,
                                                            justifySelf: fields.length > 0 ? "left" : null,
                                                            width: fields.length > 0 ? "auto" : null,
                                                        }}
                                                        type="primary"
                                                        onClick={() => add()}
                                                        block
                                                        cyan
                                                        hotkey="alt+a"
                                                        icon={<PlusOutlined />}
                                                    >
                                                        Agregar Insumo
                                                    </ButtonItem>
                                                </FormItem>
                                            ),
                                        },
                                    ],
                                }}
                                actionButtons={
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        cyanB
                                        hotkey="shift+r"
                                        style={{ width: 80}}
                                    >
                                        Recibir
                                    </ButtonItem>
                                }
                            />
                        </Form>
                    </Spin>
                </div>
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: 'center' }}>Desea continuar</h1>
                </ModalItem>
                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
                />
                <AgregarMarbetes
                    visible={this.state.modalAgregarMarbetes}
                    cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
                    marbetes={this.state.modalAgregarMarbetesMarbetes}
                    insumoId={this.state.modalAgregarMarbetesInsumoId}
                />
                <AgregarLotes
                    visible={this.state.modalAgregarLotes}
                    cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
                    lotes={this.state.modalAgregarLotesLotes}
                    insumoId={this.state.modalAgregarLotesInsumoId}
                    fechaIngresoM={this.state.modalAgregarLotesFechaIngresoM}
                    tipoEspecie={this.state.modalAgregarLotesTipoEspecie}
                    vehiculo={this.state.modalAgregarLotesVehiculo}
                />
                <MandarCorreoComodato
                    visible={this.state.modalMandarCorreoComodato}
                    id={this.state.modalMandarCorreoComodatoId}
                    cerrarMandarCorreoComodato={this.cerrarMandarCorreoComodato.bind(this)}
                />
                <ModalItem
                    visible={this.state.previewVisibleArchivo}
                    title={this.state.previewTitleArchivo}
                    footer={null}
                    onCancel={this.handleCancelArchivo}
                    spinning={false}
                >
                    <iframe
                        src={this.state.previewImageArchivo}
                        title="Vista previa PDF"
                        style={{ width: '100%', height: '80vh', border: 'none' }}
                    />
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
        comodatoFechaEntregaObligatoria: state.empresa.comodatoFechaEntregaObligatoria,
    };
};

export default connect(mapStateToProps)(AgregarOrdenComodato);